// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import useSubscription from '../../useSubscription';
import { MyBalanceChangedSubscriptionDocument, type MyBalanceChangedSubscription, type MyBalanceChangedSubscriptionVariables } from './MyBalanceChangedSubscription';

export const useMyBalanceChangedSubscription = (options: { variables?: MyBalanceChangedSubscriptionVariables, onData: (data: MyBalanceChangedSubscription) => void } ) => { 
  return useSubscription<MyBalanceChangedSubscription, MyBalanceChangedSubscriptionVariables>(MyBalanceChangedSubscriptionDocument, options);
}